export function surfacePageRange(page, limit, itemCount, total) {
  const startIndex = total ? (page - 1) * limit : 0;
  const endIndex = Math.min(startIndex + itemCount, total);
  return { startIndex, endIndex };
}
